import Keen from "keen-js";

export const client = new Keen({
  projectId: process.env.KEEN_PROJECT_ID,
  readKey: process.env.KEEN_READ_KEY
});



// WEBPACK FOOTER //
// ./src/app/utils/keen.js